import Form from 'react-bootstrap/Form'

export default function OptionSeletor(props) {
  const { offering, onChange, size = 'sm', value, name = 'option', id = '', className = '' } = props

  if (!offering.options?.length) return null

  const handleCHange = e => {
    const { value: key } = e.target
    const value = key ? offering.options.find(item => item.code === key) : null
    if (onChange) {
      onChange(name, value)
    }
  }

  return (
    <Form.Group
      controlId={id}
      className={className}>
      <Form.Control
        id={id}
        as="select"
        name={name}
        onChange={handleCHange}
        value={value}
        size={size}>
        <option value="">Select option . . .</option>
        {offering.options.map(item => (
          <option
            key={item.code}
            value={item.code}>
            {item.name}
          </option>
        ))}
      </Form.Control>
    </Form.Group>
  )
}
